import request from '@/util/request'


export const login = (data) => request.post('/api/checkLogin', data);  //登录接口（账号+密码）

export const loginCode = (data) => request.post('/api/checkLoginSms', data);  //登录接口（账号+验证码）

export const sendCode = (data) => request.post('/api/sendCode', data);  //发送验证码

export const checkPwd = (query) => request.post('/api/resetPass', query);  //修改密码

export const expireNum = (query) => request.post('/api/expireNum', query);  //获取任务逾期数量

export const logOut = (query) => request.post('/api/logout', query);  //退出登录